import { services, amountProperty, format, deadlinesArray } from '../utils';

export const wizardMutations = {
    selectDirection(state, payload){
        state.wizard.direction = payload
    },
    selectTypeApartment(state, payload){
        state.wizard.typeApartment = payload
    },
    selectOccupied(state, payload){
        state.wizard.occupied = payload
    },
    selectFloor(state, payload){
        state.wizard.floor = payload;
    },
    selectFloorsTotal(state, payload){
        state.wizard.floorsTotal = payload;
    },
    selectDoor(state, payload){
        state.wizard.door = payload;
    },
    selectSize(state, payload){
        state.wizard.m2 = payload;
    },
    selectRooms(state, payload){
        state.wizard.rooms = payload;
    },
    selectToilets(state, payload){
        state.wizard.baths = payload;
    },
    selectState(state, payload){
        state.wizard.state = payload
    },
    selectSaleState(state, payload){
        state.wizard.saleState = payload
    },
    selectBurdened(state, payload){
        state.wizard.burdened = payload
    },
    selectFeatures(state, payload){
        state.wizard.features = payload;
    },
    toggleExitDialog(state, payload){
        state.exitdialog = payload
    }
}
